import area from './area/routes'
import dispatch from './dispatch/routes'
import movement from './movement/routes'
import owner from './owner/routes'
import railway from './railway/routes'
import train from './train/routes'
import wagon from './wagon/routes'
import stat from './stat/routes'
import list from './list/routes'
import commande from './commande/routes'
import search from './search/routes'

const routes = {
  index: {
    path: 'index.consult',
    url: 'consulter',
  },
  area,
  dispatch,
  movement,
  owner,
  railway,
  train,
  wagon,
  stat,
  list,
  commande,
  search,
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/routes.js